import { render, staticRenderFns } from "./Redpack.vue?vue&type=template&id=d069ca32&scoped=true&"
import script from "./Redpack.vue?vue&type=script&lang=js&"
export * from "./Redpack.vue?vue&type=script&lang=js&"
import style0 from "./Redpack.vue?vue&type=style&index=0&id=d069ca32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d069ca32",
  null
  
)

component.options.__file = "Redpack.vue"
export default component.exports